import React from 'react';
import {StyledProps} from '../../modules/common';
import {styled} from 'styled-components';
import {H2} from '../headings';
import {mediaQueries} from '../../modules/common/styles/media-queries-breakpoints';
import {shadowBottomShort} from '../shadows.style';
import {typographyHeading4Styles} from '../../modules/common/styles';

const CenteredDiv = styled.div`
    display: flex;
    justify-content: center;
`;

const StyledH2 = styled(H2)`
    ${typographyHeading4Styles}
    margin-top: 0;
`;

const StyledH2Teloa = styled(H2)`
    ${typographyHeading4Styles}
    margin-top: 1rem;
`;

const StyledP = styled.p<PropsP>`
    margin-bottom: 24px;
    letter-spacing: normal;
    line-height: 24px;
    cursor: default;

    ${(props): string => props.$centerContentText && `text-align: center;`};

    ${(props): string =>
        props.textMargin &&
        `
        margin-left: ${props.textMargin}${props.theme.fontMeasureUnit};
        margin-right: ${props.textMargin}${props.theme.fontMeasureUnit};    
    `};

    ${mediaQueries.lessThan('small')`    
        text-align: left;
        margin-left: unset;
        margin-right: unset;  
    `}
`;

interface PropsP {
    textMargin?: number;
    $centerContentText?: boolean;
}

interface Props extends StyledProps {
    title: string;
    content: string[];
    highlighted?: boolean;
    children?: React.ReactNode;
    maxWidth?: number;
    centerContentText?: boolean;
    textMargin?: number;
    teloaCard?: boolean;
}

class UnstyledAnimationCard extends React.Component<Props> {
    render(): JSX.Element {
        const {
            className,
            title,
            content,
            children,
            centerContentText,
            textMargin,
            teloaCard,
        } = this.props;

        return (
            <div className={className}>
                {teloaCard ? (
                    <>
                        <CenteredDiv>{children}</CenteredDiv>
                        <StyledH2Teloa>{title}</StyledH2Teloa>
                    </>
                ) : (
                    <>
                        <StyledH2>{title}</StyledH2>
                        <CenteredDiv>{children}</CenteredDiv>
                    </>
                )}
                {content.map((item, i) => (
                    <StyledP
                        key={i}
                        $centerContentText={centerContentText}
                        textMargin={textMargin}
                        dangerouslySetInnerHTML={{__html: item}}
                    />
                ))}
            </div>
        );
    }
}

const AnimationCard = styled(UnstyledAnimationCard)`
    background-color: ${(props): string => props.theme.colors.arroz};
    color: ${(props): string => props.theme.colors.ballena};

    border-radius: 8px;
    ${shadowBottomShort}
    transition: box-shadow 1s ease-in-out;

    margin: 8px 12px;
    padding: 24px;

    > h2 {
        min-height: 3rem;
    }

    p:last-child {
        margin-bottom: 0;
    }

    max-width: ${(props): string =>
        props.maxWidth
            ? `${props.maxWidth}${props.theme.unitsOfMeasure.px}`
            : `${props.theme.desktopMeasures.cardWidth}${props.theme.unitsOfMeasure.px}`};

    ${mediaQueries.lessThan('medium')`
        max-width: ${(props): string =>
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access
            `${props.theme.mobileMeasures.cardWidth}${props.theme.unitsOfMeasure.px}`};     
        
        margin: 8px;
        padding: 24px 16px;
    `}
`;

export {AnimationCard, UnstyledAnimationCard};
